import { render, staticRenderFns } from "./GerenciamentoDivulgacoes.vue?vue&type=template&id=4610ccba&scoped=true"
import script from "./GerenciamentoDivulgacoes.vue?vue&type=script&lang=js"
export * from "./GerenciamentoDivulgacoes.vue?vue&type=script&lang=js"
import style0 from "./GerenciamentoDivulgacoes.vue?vue&type=style&index=0&id=4610ccba&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4610ccba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4610ccba')) {
      api.createRecord('4610ccba', component.options)
    } else {
      api.reload('4610ccba', component.options)
    }
    module.hot.accept("./GerenciamentoDivulgacoes.vue?vue&type=template&id=4610ccba&scoped=true", function () {
      api.rerender('4610ccba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GerenciamentoDivulgacoes.vue"
export default component.exports